import { render } from "./PWAPrompt.vue?vue&type=template&id=23f06bee&scoped=true"
import script from "./PWAPrompt.vue?vue&type=script&lang=js"
export * from "./PWAPrompt.vue?vue&type=script&lang=js"

import "./PWAPrompt.vue?vue&type=style&index=0&id=23f06bee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f06bee"]])

export default __exports__